import { render, staticRenderFns } from "./BasicConf.vue?vue&type=template&id=f50c01ca&scoped=true&"
import script from "./BasicConf.vue?vue&type=script&lang=js&"
export * from "./BasicConf.vue?vue&type=script&lang=js&"
import style0 from "./BasicConf.vue?vue&type=style&index=0&id=f50c01ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f50c01ca",
  null
  
)

export default component.exports